module.exports = __webpack_public_path__ + "media/images/pages/contributor_overview/img-11-f65c5dd7eb69c33ec0d91c25adc34f5c.png";